import { useTranslation } from "react-i18next";
import s from "./banner-preview.module.less";
import { mediaUrl } from "../../api/api";

export const BannerPreview = ({ banner, clearImage }) => {
    const { t } = useTranslation("CreateExhibitionPanel");
    return (
        <div>
            <img
                alt={banner.name || banner}
                width={80}
                height={25}
                src={banner.thumbUrl || mediaUrl + banner}
            />
            {clearImage && <button className={s.deleteText} onClick={() => clearImage(_, "banners", banner?.name ? banner : { name: banner })}>{t("delete")}</button>}
        </div>
    );
};